function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.07,
  d: "M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  fill: "#EB001B",
  cx: 15,
  cy: 12,
  r: 7
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  fill: "#F79E1B",
  cx: 23,
  cy: 12,
  r: 7
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF5F00",
  d: "M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7s1.2 4.5 3 5.7c1.8-1.2 3-3.3 3-5.7z"
});

function SvgMastercard2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "mastercard2_svg__icon mastercard2_svg__icon--full-color",
    width: 38,
    height: 24,
    "aria-labelledby": "pi-master"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgMastercard2;